module.exports = function(app){
    app.controller("pages.vision-provider.vision-provider-search", ["$scope", "$state", "modal", function($scope, $state, modal){

    }]);
};